import { Component, OnInit } from '@angular/core';
import { EoptionsService } from 'src/app/services/eoptions.service';
import { OptionTradeSocket } from 'src/app/app.module';
@Component({
    selector: 'app-option-chain',
    templateUrl: './option-chain.component.html',
    styleUrls: ['./option-chain.component.css']
})
export class OptionChainComponent implements OnInit {
    selectedPair = '';
    chainData: any[] = [];
    rawData: any[] = [];
    isLoading = false;
    constructor(
        private eoptionsService: EoptionsService,
        private socket: OptionTradeSocket,
    ) { }

    ngOnInit(): void {
        this.eoptionsService.selectedPair$.subscribe(pair => {
            this.selectedPair = pair;
            this.fetchChain();
        });
        this.socket.on('optionMarkPrice', this.book.bind(this))
        this.eoptionsService.selectedExpiry$.subscribe(expiry => {
            if (expiry) {
                this.filterByExpiry(expiry);
            }
        });
    }

    getStrike(symbol: string): number {
        return Number(symbol.split('-')[2]);
    }

    book(socketRes: any) {
        let pairSocket = socketRes?.symbol.split("-")[0].toLowerCase();
        pairSocket = pairSocket + 'usdt'
        let pair = this.selectedPair.toLowerCase();
        if (pairSocket !== pair) return;
        let data = socketRes.data
        if (this.chainData && this.chainData.length > 0) {
            let strike = this.getStrike(socketRes?.symbol);
            let info = {
                symbol: data?.s,
                strike: strike,
                // amount: data?.v,
                markPrice: data?.mp,
                delta: data?.d,
                gamma: data?.g,
                theta: data?.t,
                bidSize: data?.bq,
                askSize: data?.aq,
                bidPrice: data?.bo,
                askPrice: data?.ao,
                bidIV: data?.bo,
                askIV: data?.ao,
                markIV: data?.vo,
                price: data?.mp,

            }
            this.chainData.forEach((row: any) => {
                if (row.strike === info.strike) {
                    if (row.call && row.call.symbol === info.symbol) {
                        row.call = { ...row.call, ...info };
                    }
                    if (row.put && row.put.symbol === info.symbol) {
                        row.put = { ...row.put, ...info };
                    }
                }
            });
        }
    }
    fetchChain() {
        this.isLoading = true;
        this.eoptionsService.getOptionChain(this.selectedPair).subscribe({
            next: (res: any) => {
                this.isLoading = false;
                if (res.status && res.data) {
                    this.rawData = res.data; // Store raw data

                    // Extract unique expiries
                    const expiries = [...new Set(res.data.map((c: any) => c.expiryDate))].sort();

                    // Update Service
                    this.eoptionsService.setExpiries(expiries as string[]);

                    // Auto-select first expiry
                    if (expiries.length > 0) {
                        this.eoptionsService.selectExpiry(expiries[0] as string);
                    }
                } else {
                    this.chainData = [];
                    this.rawData = [];
                }
            },
            error: (err) => {
                this.isLoading = false;
                console.error(err);
            }
        });
    }

    filterByExpiry(expiry: any) {
        if (!this.rawData || this.rawData.length === 0) {
            console.log('No raw data to filter');
            return;
        }
        // Filter elements that match the expiry
        // Use loose equality to match string/number
        const filtered = this.rawData.filter((c: any) => c.expiryDate == expiry);

        this.chainData = this.processChainData(filtered);
        console.log('Processed Chain Data rows:', this.chainData);
    }

    // Helper to group calls/puts by strike
    processChainData(data: any[]): any[] {
        const rows: Record<number, any> = {};

        let maxBidSize = 0;
        let maxAskSize = 0;
        let maxIV = 0;

        for (const c of data) {
            const strike = Number(c.strikePrice);

            if (!rows[strike]) {
                rows[strike] = { strike, call: null, put: null };
            }

            if (c.side === 'CALL') rows[strike].call = c;
            if (c.side === 'PUT') rows[strike].put = c;

            maxBidSize = Math.max(maxBidSize, c.bidSize || 0);
            maxAskSize = Math.max(maxAskSize, c.askSize || 0);
            maxIV = Math.max(maxIV, c.bidIV || 0, c.askIV || 0);
        }

        maxBidSize ||= 1;
        maxAskSize ||= 1;
        maxIV ||= 1;

        Object.values(rows).forEach((r: any) => {
            if (r.call) {
                r.call.bidSizeIntensity = this.normalize(r.call.bidSize, maxBidSize);
                r.call.askSizeIntensity = this.normalize(r.call.askSize, maxAskSize);
                r.call.bidIVIntensity = this.normalize(r.call.bidIV, maxIV);
                r.call.askIVIntensity = this.normalize(r.call.askIV, maxIV);
            }

            if (r.put) {
                r.put.bidSizeIntensity = this.normalize(r.put.bidSize, maxBidSize);
                r.put.askSizeIntensity = this.normalize(r.put.askSize, maxAskSize);
                r.put.bidIVIntensity = this.normalize(r.put.bidIV, maxIV);
                r.put.askIVIntensity = this.normalize(r.put.askIV, maxIV);
            }
        });

        return Object.values(rows).sort((a: any, b: any) => a.strike - b.strike);
    }

    normalize(value: number, max: number): number {
        if (!value || !max) return 0;
        return Math.min(value / max, 1);
    }

    getGreenHeat(intensity: number = 0): string {
        return `rgba(14, 203, 129, ${intensity * 0.6})`;
    }

    getRedHeat(intensity: number = 0): string {
        return `rgba(246, 70, 93, ${intensity * 0.6})`;
    }



    selectContract(row: any, type: any) {
        this.eoptionsService.selectContract({
            symbol: type === 'CALL' ? row.call.symbol : row.put.symbol, // Use the specific option symbol
            strike: row.strike,
            type: type,
            expiry: type === 'CALL' ? row.call.expiryDate : row.put.expiryDate,
            price: row.call.markPrice
        });
    }


}
